import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../api';
import './Admin.css';

export default function AdminForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setSubmitting(true);
    try {
      const data = await api.post('/api/auth/forgot_password.php', { email: email.trim() });
      setSuccess(data.message || 'If an account exists for that email, a reset link has been sent.');
    } catch (err) {
      setError(err.error || 'Request failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="admin-login-box">
        <h1>Forgot password</h1>
        <p className="admin-login-subtitle">Enter your email and we&apos;ll send a reset link if an account exists.</p>
        {error && <div className="admin-message error">{error}</div>}
        {success && <div className="admin-message success">{success}</div>}
        <form onSubmit={handleSubmit}>
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
          />
          <button type="submit" disabled={submitting}>
            {submitting ? 'Sending…' : 'Send reset link'}
          </button>
        </form>
        <Link to="/admin/login" className="admin-login-link">Back to sign in</Link>
      </div>
    </div>
  );
}
